var map = {
	"./australia": 554,
	"./australia.js": 554,
	"./cricinfo/africa": 543,
	"./cricinfo/africa.js": 543,
	"./cricinfo/australia": 544,
	"./cricinfo/australia.js": 544,
	"./cricinfo/bangladesh": 545,
	"./cricinfo/bangladesh.js": 545,
	"./cricinfo/global": 546,
	"./cricinfo/global.js": 546,
	"./cricinfo/india": 547,
	"./cricinfo/india.js": 547,
	"./cricinfo/newzealand": 548,
	"./cricinfo/newzealand.js": 548,
	"./cricinfo/pakistan": 549,
	"./cricinfo/pakistan.js": 549,
	"./cricinfo/srilanka": 550,
	"./cricinfo/srilanka.js": 550,
	"./cricinfo/unitedkingdom": 551,
	"./cricinfo/unitedkingdom.js": 551,
	"./cricinfo/unitedstates": 552,
	"./cricinfo/unitedstates.js": 552,
	"./en-global": 555,
	"./en-global.js": 555,
	"./india": 556,
	"./india.js": 556,
	"./philippines": 557,
	"./philippines.js": 557,
	"./southafrica": 558,
	"./southafrica.js": 558,
	"./unitedkingdom": 559,
	"./unitedkingdom.js": 559,
	"./unitedstates": 560,
	"./unitedstates.js": 560
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 553;



//////////////////
// WEBPACK FOOTER
// ../app/lib/utils/editions/config ^\.\/.*$
// module id = 553
// module chunks = 0